import { fileReadyToUpload } from '../../utils/redux/status';

import actionTypes from './actionTypes';

export const initialState = {
  awaitingFileSelection: true,
  files: [],
  checkedList: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.setAwaitingFileSelection:
      return { ...state, awaitingFileSelection: action.value };
    case actionTypes.setFiles:
      return { ...state, files: action.value };
    // TODO: Genericize all of these reducer methods that rely on merging fields together
    case actionTypes.setFieldValue:
      // add/replace to the values array for only file at given index
      const { fileIndex, fieldIndex, field, value } = action.payload;
      const newValuesObject = { field, value };
      const file = state.files.find((f, i) => {
        return i === fileIndex;
      });
      const newValues =
        // check if there is an existing object that matches the current field ID
        file.values.filter((obj) => {
          return obj.field.id == field.id;
        }).length == 0
          ? // Append new object if none exists, and make sure to sort by field.id
            [...file.values, newValuesObject].sort((a, b) => {
              return a.field.id - b.field.id;
            })
          : // Replace existing object if it's already there
            file.values.map((obj) => {
              if (obj.field.id == field.id) {
                return newValuesObject;
              }
              return obj;
            });

      const newFile = {
        ...file,
        values: newValues,
      };
      // replace file in files array
      const newFiles = state.files.map((file, index) => {
        if (index == fileIndex) {
          return newFile;
        }
        return file;
      });
      // update state
      return { ...state, files: newFiles };

    case actionTypes.setCopyFieldValue:
      const { copyFrom, copyTo } = action.payload;

      const copyFromValues = copyFrom.values.filter((value) => {
        if (value.field.name !== 'Title') return value;
      });

      const copyFilesIndex = copyTo.map((file) => {
        return file.index;
      });

      const FilesToCopy = copyTo.map((file) => {
        const fieldTitleValue = file.values.filter((value) => {
          if (value.field.name === 'Title') return value;
        });
        const mergeValues = [...fieldTitleValue, ...copyFromValues];
        const copyValues = {
          ...file,
          readyToUpload: copyFrom.readyToUpload,
          values: mergeValues,
        };
        return copyValues;
      });

      const copyFiles = state.files.map((file) => {
        if (copyFilesIndex.includes(file.index)) {
          let fileToCopy;
          FilesToCopy.filter((copyFile) => {
            if (copyFile.index === file.index) {
              fileToCopy = copyFile;
            }
          });
          return fileToCopy;
        }
        return file;
      });

      return { ...state, files: copyFiles };

    case actionTypes.updateFileReadyToUploadFlag:
      // add/replace to the values array for only file at given index
      const file2 = state.files.find((f, i) => {
        return i === action.fileIndex;
      });

      const newFile2 = {
        ...file2,
        readyToUpload: fileReadyToUpload(file2, file2.infoFields),
      };
      // replace file in files array
      const newFiles2 = state.files.map((file, index) => {
        if (index == action.fileIndex) {
          return newFile2;
        }
        return file;
      });
      // update state
      return { ...state, files: newFiles2 };
    case actionTypes.updateFileUploadProgress:
      // add/replace to the values array for only file at given index
      const file3 = state.files.find((f, i) => {
        return i === action.fileIndex;
      });
      const newFile3 = {
        ...file3,
        uploadProgress: action.percent,
      };
      // replace file in files array
      const newFiles3 = state.files.map((file, index) => {
        if (index == action.fileIndex) {
          return newFile3;
        }
        return file;
      });
      // update state
      return { ...state, files: newFiles3 };
    case actionTypes.updateFileStatus:
      // add/replace to the values array for only file at given index
      const file4 = state.files.find((f, i) => {
        return i === action.fileIndex;
      });
      const newFile4 = {
        ...file4,
        status: action.status,
      };
      // replace file in files array
      const newFiles4 = state.files.map((file, index) => {
        if (index == action.fileIndex) {
          return newFile4;
        }
        return file;
      });
      // update state
      return { ...state, files: newFiles4 };
    case actionTypes.updateFileError:
      // add/replace to the values array for only file at given index
      const file5 = state.files.find((f, i) => {
        return i === action.fileIndex;
      });
      const newFile5 = {
        ...file5,
        error: action.error,
      };
      // replace file in files array
      const newFiles5 = state.files.map((file, index) => {
        if (index == action.fileIndex) {
          return newFile5;
        }
        return file;
      });
      // update state
      return { ...state, files: newFiles5 };

    case actionTypes.abortUpload:
      // add/replace to the values array for only file at given index
      const abortUploadFile = state.files.find((f, i) => {
        return i === action.fileIndex;
      });
      const updatedAbortUploadFile = {
        ...abortUploadFile,
        abortUpload: action.isAbort,
      };
      // replace file in files array
      const replaceAbortUploadFile = state.files.map((file, index) => {
        if (index == action.fileIndex) {
          return updatedAbortUploadFile;
        }
        return file;
      });
      // update state
      return { ...state, files: replaceAbortUploadFile };

    case actionTypes.setUploadInfo:
      // add/replace to the values array for only file at given index
      const uploadInfoFile = state.files.find((f, i) => {
        return i === action.fileIndex;
      });
      const updatedUploadInfoFile = {
        ...uploadInfoFile,
        uploadInfo: action.uploadInfo,
      };
      // replace file in files array
      const replaceUploadInfoFile = state.files.map((file, index) => {
        if (index == action.fileIndex) {
          return updatedUploadInfoFile;
        }
        return file;
      });
      // update state
      return { ...state, files: replaceUploadInfoFile };

    case actionTypes.removeFile:
      return {
        ...state,
        files: state.files.filter((f, i) => {
          return i !== action.fileIndex;
        }),
      };
    case actionTypes.setCheckedList:
      return { ...state, checkedList: action.checkedValue };
    case actionTypes.setRetryStatus:
      // add/replace to the values array for only file at given index
      const retryFile = state.files.find((f, i) => {
        return i === action.fileIndex;
      });
      const updatedRetryFile = {
        ...retryFile,
        activateRetry: action.isRetry,
      };
      // replace file in files array
      const replaceRetryFile = state.files.map((file, index) => {
        if (index == action.fileIndex) {
          return updatedRetryFile;
        }
        return file;
      });
      // update state
      return { ...state, files: replaceRetryFile };
    default:
      return state;
  }
}

export default reducer;
